<template>
  <!-- model-value is always null: this acts as a one-shot trigger, not a bound select.
       After emitting 'switch', the parent navigates away so no selected state is needed. -->
  <RevInputSelectSearchable
    :id
    hide-checkboxes
    :label
    :model-value="null"
    :no-options-message="i18n(translations.noProductFound)"
    :options
    search-placement="dropdown"
    @update:model-value="onSelect"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import {
  type Option,
  RevInputSelectSearchable,
} from '@ds/components/InputSelectSearchable'

import translations from './ProductSwitcher.translations'

defineProps<{
  id: string
  label: string
  options: { id: string; label: string; value: string }[]
}>()

const emit = defineEmits<{
  switch: [option: { value: string }]
}>()

const i18n = useI18n()

function onSelect(opt: Option | null) {
  if (opt && 'value' in opt) {
    emit('switch', { value: String(opt.value) })
  }
}
</script>
